module.exports = __webpack_public_path__ + "assets/img/09-m.03a5941.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/09-m.jpg
// module id = 5QSQ
// module chunks = 0